import { FormattedMessage } from 'react-intl';
import offlineMapsSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-offline-maps.avif';
import trailConditionsSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-trail-conditions.avif';
import wrongTurnAlertsSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-wrong-turn-alerts.avif';
import liveShareSrc from './feature-thumb-live-share.avif';
import memberDealsSrc from './feature-thumb-member-deals.avif';
import garminSrc from './feature-thumb-send-to-garmin.avif';
import MembershipIncludes from './MembershipIncludes';

const memberDealsRow = {
  body: <FormattedMessage defaultMessage="Exclusive savings on apparel, outdoor accommodations, flights, and more" />,
  src: memberDealsSrc,
  title: <FormattedMessage defaultMessage="Member Deals" />
};

const offlineMapsRow = {
  body: <FormattedMessage defaultMessage="Download maps so you always know where you are, even without cell service" />,
  src: offlineMapsSrc,
  title: <FormattedMessage defaultMessage="Offline Maps" />
};

const trailConditionsRow = {
  body: <FormattedMessage defaultMessage="Plan for trail-specific weather, snow depth, and more" />,
  src: trailConditionsSrc,
  title: <FormattedMessage defaultMessage="Trail Conditions" />
};

const wrongTurnAlertsRow = {
  body: <FormattedMessage defaultMessage="Focus on the beauty around you, not the map, with wrong-turn alerts" />,
  src: wrongTurnAlertsSrc,
  title: <FormattedMessage defaultMessage="Wrong-Turn Alerts" />
};

const garminRow = {
  body: <FormattedMessage defaultMessage="Have the route at your wrist. Upload AllTrails routes to your Garmin device" />,
  src: garminSrc,
  title: <FormattedMessage defaultMessage="Send Routes to Garmin" />
};

const liveShareRow = {
  body: <FormattedMessage defaultMessage="Keep your loved ones in the loop by sharing your real-time trail activity" />,
  src: liveShareSrc,
  title: <FormattedMessage defaultMessage="Live Share" />
};

const usDefaultRows = [offlineMapsRow, trailConditionsRow, memberDealsRow, wrongTurnAlertsRow, garminRow];
const usMemberDealsFirstRows = [memberDealsRow, offlineMapsRow, trailConditionsRow, wrongTurnAlertsRow, garminRow];
const nonUsRows = [offlineMapsRow, trailConditionsRow, wrongTurnAlertsRow, garminRow, liveShareRow];

type Props = {
  isInUs: boolean;
  memberDealsFirst?: boolean;
};

export default function PlusMembershipIncludes({ isInUs, memberDealsFirst }: Props) {
  const rows = isInUs ? (memberDealsFirst ? usMemberDealsFirstRows : usDefaultRows) : nonUsRows;

  return <MembershipIncludes label={<FormattedMessage defaultMessage="Plus membership includes" />} rows={rows} />;
}
